import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import SEO from '../components/SEO';

const CookiesPolicy = () => {
  // Schema.org structured data for cookies policy page
  const cookiesSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Cookies Policy - Robomec Automation",
    "description": "Cookies Policy for Robomec Automation Private Limited. Learn how we use cookies and similar technologies on our website.",
    "url": "https://www.robomecautomation.com/cookies-policy"
  };

  return (
    <>
      <SEO
        title="Cookies Policy"
        description="Cookies Policy for Robomec Automation Private Limited. Learn how we use cookies and similar technologies on our website."
        canonicalUrl="https://www.robomecautomation.com/cookies-policy"
        keywords={[
          "Robomec Automation cookies policy",
          "website cookies",
          "cookie settings",
          "cookie preferences"
        ]}
        schema={cookiesSchema}
      />
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <h1 className="mb-4">Cookies Policy</h1>
            <p className="text-muted mb-4">Last Updated: November 15, 2023</p>

            <h2 className="mt-5 mb-3">1. What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer, smartphone, or other device when you access the internet. They are widely used to make websites work more efficiently, as well as to provide information to the owners of the site.
            </p>
            <p>
              Cookies allow our website to remember your actions and preferences (such as login, language, font size, and other display preferences) over a period of time, so you don't have to keep re-entering them whenever you come back to the site or browse from one page to another.
            </p>

            <h2 className="mt-5 mb-3">2. How We Use Cookies</h2>
            <p>
              Robomec Automation Private Limited uses cookies for a variety of reasons. We use cookies to:
            </p>
            <ul>
              <li>Make our website work as you'd expect</li>
              <li>Remember your settings during and between visits</li>
              <li>Improve the speed/security of the site</li>
              <li>Allow you to share pages with social networks like Facebook, LinkedIn, and Twitter</li>
              <li>Continuously improve our website for you</li>
              <li>Make our marketing more efficient</li>
            </ul>

            <h2 className="mt-5 mb-3">3. Types of Cookies We Use</h2>
            <p>We use the following types of cookies:</p>

            <h3 className="mt-4 mb-2">3.1 Strictly Necessary Cookies</h3>
            <p>
              These are cookies that are required for the operation of our website. They include, for example, cookies that enable you to log into secure areas of our website.
            </p>

            <h3 className="mt-4 mb-2">3.2 Analytical/Performance Cookies</h3>
            <p>
              These allow us to recognize and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily.
            </p>

            <h3 className="mt-4 mb-2">3.3 Functionality Cookies</h3>
            <p>
              These are used to recognize you when you return to our website. This enables us to personalize our content for you, greet you by name, and remember your preferences (for example, your choice of language or region).
            </p>

            <h3 className="mt-4 mb-2">3.4 Targeting Cookies</h3>
            <p>
              These cookies record your visit to our website, the pages you have visited, and the links you have followed. We will use this information to make our website and the advertising displayed on it more relevant to your interests. We may also share this information with third parties for this purpose.
            </p>

            <h2 className="mt-5 mb-3">4. Third-Party Cookies</h2>
            <p>
              In some special cases, we also use cookies provided by trusted third parties. The following section details which third-party cookies you might encounter through this site.
            </p>
            <ul>
              <li>
                This site uses Google Analytics which is one of the most widespread and trusted analytics solutions on the web for helping us to understand how you use the site and ways that we can improve your experience.
              </li>
              <li>
                We also use social media buttons and/or plugins on this site that allow you to connect with your social network in various ways. For these to work, social media sites will set cookies through our site which may be used to enhance your profile on their site or contribute to the data they hold for various purposes outlined in their respective privacy policies.
              </li>
            </ul>

            <h2 className="mt-5 mb-3">5. How to Control and Delete Cookies</h2>
            <p>
              You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
            </p>
            <p>
              To modify your cookie settings, please visit the help section of your browser or follow these links for instructions:
            </p>
            <ul>
              <li>
                <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a>
              </li>
              <li>
                <a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a>
              </li>
              <li>
                <a href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noopener noreferrer">Firefox</a>
              </li>
              <li>
                <a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a>
              </li>
            </ul>

            <h2 className="mt-5 mb-3">6. Changes to Our Cookies Policy</h2>
            <p>
              We may update our cookies policy from time to time. We will notify you of any changes by posting the new cookies policy on this page and updating the "Last Updated" date at the top of this policy.
            </p>

            <h2 className="mt-5 mb-3">7. Contact Us</h2>
            <p>
              If you have any questions about this cookies policy, please contact us at:
            </p>
            <address className="mt-3">
              <strong>Robomec Automation Private Limited</strong><br />
              B133, Opp Sukrut Company<br />
              Near Bharat Petroleum Pump<br />
              Bhambholi, Chakan<br />
              Pune 410501, INDIA<br /><br />
            </address>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CookiesPolicy; 